<template>
  <navbar>
    <my-button @click="$router.push('/profile')">profile</my-button>
  </navbar>

  <div class="block">
    <div style="font-size: 75px;">Alc</div>
    <div class="column">
      <div class="line" v-for="p_alc in persons_alc">
        <div class="b">{{ p_alc.number }}. {{ p_alc.username }}</div>
        <div class="b">{{ p_alc.V }}</div>
      </div>
    </div>
  </div>

  <div class="block">
    <div style="font-size: 75px;">No Alc</div>
    <div class="column">
      <div class="line" v-for="p in persons">
        <div class="b">{{ p.number }}. {{ p.username }}</div>
        <div class="b">{{ p.V }}</div>
      </div>
    </div>
  </div>
</template>


<script>
import Navbar from '@/components/Navbar.vue';
// import ky from 'ky';

export default {
  components: {
    Navbar
  },
  data() {
    return {
      persons_alc: [],
      persons: [],
    }
  },
  methods: {
    async get_top() {
      let res = await fetch('/api/top', {
        method: "POST",
        headers: {"content-type": "application/json"},
      })
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data);
        this.persons_alc = data['persons_alc'];
        this.persons = data['persons'];
      }
    },
    async isauth() {
      let res = await fetch('/api/auth/isauth', {
        method: "POST",
        headers: {"content-type": "application/json"},
      });
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data['auth']);
        if (!data['auth']) {
          this.$router.push('/auth/log_in');
        }
      }
    }
  },
  mounted() {
    this.isauth();
    this.get_top();
  }
}
</script>


<style scoped>
.block {
  padding: 75px;
  text-align: center;
}

.column {
  width: fit-content;
  min-width: 75%;
  margin: auto;
}
.line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.b {
  color: black;
}
</style>
